import { AnimatePresence, motion } from "framer-motion";
import { X } from "lucide-react";
import { waLink, itemCount } from "../data/site";

export const CategoryModal = ({ category, onClose }) => (
  <AnimatePresence>
    {category && (
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.3 }}
        className="fixed inset-0 z-[80] flex items-center justify-center p-4"
        data-testid="product-spec-modal"
      >
        <div className="absolute inset-0 bg-obsidian/85 backdrop-blur-md" onClick={onClose} />
        <motion.div
          initial={{ y: 64, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 64, opacity: 0 }}
          transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
          data-lenis-prevent
          className="relative z-10 max-h-[85vh] w-full max-w-2xl overflow-y-auto rounded-3xl border border-white/10 bg-silt p-6 sm:p-9"
          style={{ WebkitOverflowScrolling: "touch", touchAction: "pan-y", overscrollBehavior: "contain" }}
        >
          <button
            onClick={onClose}
            aria-label="Close category details"
            data-testid="product-spec-modal-close-button"
            className="absolute right-5 top-5 flex h-9 w-9 items-center justify-center rounded-full border border-white/10 text-fog transition-all duration-300 hover:border-blue/50 hover:text-blue"
          >
            <X size={16} />
          </button>
          <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-blue">
            {itemCount(category)} products
          </p>
          <h3 className="mt-3 pr-10 font-display text-2xl font-medium tracking-tight text-cream sm:text-3xl">
            {category.name}
          </h3>
          <p className="mt-3 text-sm leading-relaxed text-fog">{category.blurb}</p>

          <div className="mt-7 space-y-6">
            {category.groups.map((g) => (
              <div key={g.label}>
                <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-ash">
                  {g.label}
                </p>
                <div className="mt-3 flex flex-wrap gap-2">
                  {g.items.map((item) => (
                    <span
                      key={item}
                      className="rounded-full border border-white/10 bg-steel/60 px-3.5 py-1.5 text-xs text-cream/90"
                    >
                      {item}
                    </span>
                  ))}
                </div>
              </div>
            ))}
          </div>

          <a
            href={waLink(`Hi Ramaani Electricals, do you have ${category.name} in stock? I'd like to visit the experience centre.`)}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="product-spec-modal-enquire-button"
            className="mt-8 flex w-full items-center justify-center gap-2 rounded-full bg-blue px-6 py-3.5 text-sm font-semibold text-white transition-all duration-300 hover:bg-bluebright hover:shadow-[0_0_32px_rgba(46,107,255,0.35)] sm:inline-flex sm:w-auto"
          >
            Check availability on WhatsApp
          </a>
        </motion.div>
      </motion.div>
    )}
  </AnimatePresence>
);
